<template>
    <toolbar-option>
        <template slot="primary">
            <toggle
                :value="isChecked"
                :messages="messages"
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

export default {
    name: 'aria-hidden',
    mixins: [baseOption],

    data() {
        return {
            isChecked: false,
            displayName: 'aria-hidden',
            messages: {
                checked: 'On',
                unchecked: 'Off',
            },
        };
    },

    methods: {
        onInput(isChecked) {
            this.selectedElements[0].ariaHiddenNew = isChecked;

            this.checked = isChecked;
            this.onOptionChange(isChecked);
            this.setChangedData(true);
        },

        onSelectedElement() {
            this.isChecked = this.selectedElements[0].ariaHiddenNew;
        },
    },
};
</script>
